var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('h1',{staticClass:"mb-3"},[_vm._v("Store Settings")]),_c('b-tabs',{attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Closures","active":""}},[_c('closures')],1),_c('b-tab',{attrs:{"title":"Opening Hours"}},[_c('opening-hours')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }